import React from 'react';

const SendIcon = ({ size = 20, color = 'white' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0002 4.33333V15.6667M10.0002 4.33333C11.0982 4.33333 15 9.3333 15 9.3333M10.0002 4.33333C8.90217 4.33332 5 9.33333 5 9.33333"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SendIcon;
